"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaletteCursorTarget = exports.EyeDropperKeyboardEventKey = void 0;
var EyeDropperKeyboardEventKey;
(function (EyeDropperKeyboardEventKey) {
    EyeDropperKeyboardEventKey["esc"] = "Escape";
    EyeDropperKeyboardEventKey["enter"] = "Enter";
    EyeDropperKeyboardEventKey["space"] = " ";
    EyeDropperKeyboardEventKey["switch"] = "Shift";
    EyeDropperKeyboardEventKey["copy"] = "c";
})(EyeDropperKeyboardEventKey = exports.EyeDropperKeyboardEventKey || (exports.EyeDropperKeyboardEventKey = {}));
var PaletteCursorTarget;
(function (PaletteCursorTarget) {
    PaletteCursorTarget["colormap"] = "colormap";
    PaletteCursorTarget["hue"] = "hue";
    PaletteCursorTarget["alpha"] = "alpha";
})(PaletteCursorTarget = exports.PaletteCursorTarget || (exports.PaletteCursorTarget = {}));
